import React from 'react';
import { XIcon, CheckIcon, ArrowDownIcon } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
import { comparison } from '../data/offer';
export function BeforeAfter() {
  return <section className="w-full bg-cream" aria-labelledby="compare-heading" data-id="element-21" data-mp="3ogauvp93qz4s">
      <div className="mx-auto max-w-5xl px-4 py-14 sm:px-5 sm:py-24" data-id="element-22" data-mp="3shcu4630rb6r">
        <SectionLabel data-id="element-23" data-mp="3sfjpewbyv11e">Before vs. after</SectionLabel>

        <h2 id="compare-heading" className="mt-5 max-w-3xl font-display text-[1.75rem] font-semibold leading-tight text-ink sm:mt-6 sm:text-[2.75rem]" data-id="element-24" data-mp="3epokc9g8sysy">
          Stop guessing. Start training with a system.
        </h2>

        <ul className="mt-9 space-y-3 sm:hidden" data-id="element-25" data-mp="34ppc6dnqjagm">
          {comparison.map(row => <li key={row.without} className="border border-line bg-white" data-id="element-26" data-mp="39r4ye91nfn0l">
              <div className="flex items-start gap-3 px-4 py-3.5" data-id="element-27" data-mp="2vsf04q33fhan">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-terracotta-dark" aria-hidden="true" data-id="element-28" data-mp="30px92gh41win" />
                <span className="text-sm leading-snug text-muted" data-id="element-29" data-mp="x2qvjglq55wp">
                  {row.without}
                </span>
              </div>
              <div className="flex items-center gap-2 border-y border-line bg-sand px-4 py-1.5" data-id="element-30" data-mp="172hoveyjtev7">
                <ArrowDownIcon className="h-3 w-3 shrink-0 text-terracotta" aria-hidden="true" data-id="element-31" data-mp="123wq7jyy338v" />
                <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-muted" data-id="element-32" data-mp="eeluigwgbz1l">
                  With the method
                </span>
              </div>
              <div className="flex items-start gap-3 bg-moss-soft px-4 py-3.5" data-id="element-33" data-mp="o45drno2tuwz">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-moss" aria-hidden="true" data-id="element-34" data-mp="jdf7m87tto18" />
                <span className="text-sm font-medium leading-snug text-ink" data-id="element-35" data-mp="3rre6bhm6nnif">
                  {row.with}
                </span>
              </div>
            </li>)}
        </ul>

        <table className="mt-12 hidden w-full border-collapse border border-line text-left sm:table" data-id="element-36" data-mp="1qpy67ukil2rr">
          <caption className="sr-only" data-id="element-37" data-mp="1vo9fa32zj98x">
            Life without the Perfect Dog Method compared with life after it
          </caption>
          <thead data-id="element-38" data-mp="20iwvzfrqyzcy">
            <tr data-id="element-39" data-mp="24hw7jj7zhudd">
              <th scope="col" className="w-1/2 border-b border-r border-line bg-sand px-5 py-4 text-[11px] font-bold uppercase tracking-[0.16em] text-muted sm:px-7" data-id="element-40" data-mp="24ie1g976bwi4">
                Without the method
              </th>
              <th scope="col" className="w-1/2 border-b border-line bg-moss-soft px-5 py-4 text-[11px] font-bold uppercase tracking-[0.16em] text-moss sm:px-7" data-id="element-41" data-mp="1gsjqjx6f0i0i">
                With the method
              </th>
            </tr>
          </thead>
          <tbody data-id="element-42" data-mp="2sa2w3w7gwx28">
            {comparison.map(row => <tr key={row.without} className="bg-white align-top" data-id="element-43" data-mp="2x5idgy4opb3e">
                <td className="border-b border-r border-line px-5 py-5 sm:px-7" data-id="element-44" data-mp="37b9vjmvynrw7">
                  <span className="flex items-start gap-3" data-id="element-45" data-mp="32bx6cvhma8qg">
                    <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-terracotta-dark" aria-hidden="true" data-id="element-46" data-mp="32cfasfefnt9g" />
                    <span className="text-sm leading-relaxed text-muted" data-id="element-47" data-mp="2tiaf9iocttnl">
                      {row.without}
                    </span>
                  </span>
                </td>
                <td className="border-b border-line px-5 py-5 sm:px-7" data-id="element-48" data-mp="2jkmhejvgc617">
                  <span className="flex items-start gap-3" data-id="element-49" data-mp="2jnide2nqokn0">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-moss" aria-hidden="true" data-id="element-50" data-mp="2emkzw3doceru" />
                    <span className="text-sm font-medium leading-relaxed text-ink" data-id="element-51" data-mp="cv7vdffmc8wb">
                      {row.with}
                    </span>
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </section>;
}